export default {
  Bl: "invalid_api_key",
  zl: "blacklisted",
  jl: "no_device_identifier",
  Cl: "invalid_json_response",
  yl: "empty_response",
  __: "sdk_auth_error",
};
